<template>
  <b-modal ref="modal" :title="this.$t('vizualization')" @ok="okClicked">
    <service-picker v-model="form.serviceId" :services="getServices" :allow-multiple="false" />
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ServicePicker from '@/components/inputs/ServicePicker.vue';

export default {
  name: 'PlanItemModalAddForm',
  data() {
    return {
      form: {
        serviceId: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'getServices',
    ]),
  },
  methods: {
    okClicked() {
      this.$emit('service-picked', this.form.serviceId);
      this.form.serviceId = null;
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
  components: {
    ServicePicker,
  },
};
</script>

<style scoped>

</style>
